import { useMemo } from 'react'

import useBrands from 'pared/layouts/hooks/useBrands'

import { IApiDataType } from '../types'
import useCorporateGroupFilter, { HAS_COMPANY } from './useCorporateFilter'

const useCorporateWithoutBreakdownFilter = () => {
  const { brand } = useBrands()
  const { data, loading } = useCorporateGroupFilter()

  return {
    data: useMemo((): IApiDataType => {
      if (!data) return null

      const { values, defaultValue } = data
      const valuesWithoutBreakdown = values.filter(
        (v) => !/Breakdown By/.test(v.label),
      )

      return {
        values: HAS_COMPANY.includes(brand)
          ? valuesWithoutBreakdown.filter((v) => v.label !== 'Company')
          : valuesWithoutBreakdown,
        defaultValue,
      }
    }, [data, brand]),
    loading,
  }
}

export default useCorporateWithoutBreakdownFilter
